module.exports = __webpack_public_path__ + "static/img/30016 (5).aeed9da.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30016 (5).webp
// module id = SN1s
// module chunks = 14